import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Words, Page } from 'pages'
import { useSearchParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { actions } from 'store'
import { wordsRQ } from 'store/hooks'
import { isBoolean } from 'lodash'

const AssessmentDef = (props) => {
    const { student, customHeader, comment } = props
    const { wordDefs = {} } = useSelector(state => state.words)

    const { refetch } = wordsRQ.useGetWordDefs()

    const { visible_type, name, word_defs, points } = wordDefs || {}

    const dispatch = useDispatch()

    const [searchParams] = useSearchParams();

    const assessmentDefID = searchParams.get('assessmentDef');
    const testTakerID = searchParams.get('testTaker');

    useEffect(() => {
        if (assessmentDefID)
            refetch()
    }, [assessmentDefID])

    useEffect(() => {
        dispatch(actions.updateAssessment({ reading_assessment_def_id: assessmentDefID }))
        dispatch(actions.editTestTaker({ test_taker_id: testTakerID }))
    }, [])

    return (
        <Page>
            <Words
                print={true}
                type={visible_type}
                name={name}
                words={word_defs}
                points={points}
                comment={comment}
                student={isBoolean(student) ? student : true}
                showErrorTypes={false}
                customHeader={customHeader}
            />
        </Page>
    )
}

export default AssessmentDef